export const scheduleMembershipQueryKeys = {
  scheduleMembership: (queryParams = {}) => ['scheduleMembership', queryParams]
}
